import React from 'react';

const My = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3228 6.76852C17.3229 7.41134 17.1964 8.04788 16.9504 8.6418C16.7045 9.23571 16.344 9.77537 15.8895 10.23C15.435 10.6845 14.8954 11.0452 14.3015 11.2912C13.7077 11.5373 13.0712 11.664 12.4283 11.664C11.1301 11.6642 9.88499 11.1486 8.96691 10.2307C8.04882 9.31277 7.53297 8.06776 7.53284 6.76952C7.53277 6.1267 7.65932 5.49016 7.90526 4.89625C8.1512 4.30234 8.5117 3.76268 8.9662 3.30809C9.8841 2.39 11.1291 1.87416 12.4273 1.87402C13.7256 1.87389 14.9707 2.38949 15.8888 3.30738C16.8069 4.22528 17.3227 5.47029 17.3228 6.76852ZM12.4278 13.1615C5.37884 13.1615 2.63684 17.6475 2.63684 19.7345C2.63684 21.8205 8.47384 22.3765 12.4278 22.3765C16.3818 22.3765 22.2188 21.8205 22.2188 19.7345C22.2188 17.6475 19.4768 13.1615 12.4278 13.1615Z"
        fill="#191F28"
      />
    </svg>
  );
};

export default My;
